<template>
  <div id="app">
    <el-header>
      <site-header></site-header>
    </el-header>
    <el-container>
      <router-view/>
    </el-container>
    <el-footer>
      <site-footer></site-footer>
    </el-footer>
    <!--<home></home>-->
  </div>
</template>

<script>
import SiteHeader from '@/components/Header'
import SiteFooter from '@/components/Footer'

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter
  }
}
</script>

<style lang="stylus">
#app
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  .el-container
    display: inline-block

  


</style>



// WEBPACK FOOTER //
// src/App.vue